module.exports = __webpack_public_path__ + "static/img/menu.fa50c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/zh/pc/imgs/menu.png
// module id = 1p5s
// module chunks = 13